import {AfterViewInit, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from "rxjs";
@Component({
  selector: 'ral-alert-argumentario',
  templateUrl: './alert-argumentario.component.html',
  styleUrls: ['./alert-argumentario.component.scss']
})
export class AlertArgumentarioComponent
{
  response:string = "OK";
  constructor
  (
    public dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ){
  }

  static mostrarArgumentario(titulo:string,lineas:string[],bloquearCierre:boolean=false,btnCierre:boolean=true, aviso: boolean=false, dialog:MatDialog):void
  {
    let clase = "normal-background";
    let color = "white"

    if (aviso){
      clase = "error-background";
      color = "#e8d9cf"
    }

    const dialogRef = dialog.open(AlertArgumentarioComponent,
      {
        data: {titulo: titulo,lineas:lineas, mostrarBtnCierre:btnCierre, msgError: aviso},
        disableClose:bloquearCierre//SI ES FALSE => permite cerrar al clicar fuera. SI es true , no puede (de esa manera)
      });

    dialogRef.addPanelClass(clase);
    // @ts-ignore
    this.getElementsByXPath("//*[contains(@class, '" + clase + "')]/mat-dialog-container/div/div")[0].style.backgroundColor =color;

    dialogRef.afterClosed()
      .subscribe(result =>
      {
      });
  }

  static mostrarArgumentarioRes(titulo:string,lineas:string[],bloquearCierre:boolean=false,btnCierre:boolean=true, aviso: boolean=false, dialog:MatDialog, aceptar: boolean =false):Observable<any>
  {
    let clase = "normal-background";
    let color = "white"

    if (aviso){
      clase = "error-background";
      color = "#e8d9cf"
    }

    const dialogRef = dialog.open(AlertArgumentarioComponent,
      {
        data: {titulo: titulo,lineas:lineas, mostrarBtnCierre:btnCierre, msgError: aviso, mostrarBtnAceptar: aceptar},
        disableClose:bloquearCierre//SI ES FALSE => permite cerrar al clicar fuera. SI es true , no puede (de esa manera)
      });

    dialogRef.addPanelClass(clase);
    // @ts-ignore
    this.getElementsByXPath("//*[contains(@class, '" + clase + "')]/mat-dialog-container/div/div")[0].style.backgroundColor =color;

    return dialogRef.afterClosed()
  }

  //funcion unica y exclusivamente para personalizar el backgroun del MatDialog
  private static getElementsByXPath(xpath:string)
  {
    let results = [];
    let query = document.evaluate(xpath, document,
      null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
    for (let i = 0, length = query.snapshotLength; i < length; ++i) {
      results.push(query.snapshotItem(i));
    }
    return results;
  }
}
export interface DialogData
{
  titulo: string;
  lineas: string[];
  mostrarBtnCierre : boolean;
  msgError: boolean;
  mostrarBtnAceptar: boolean;
}

